/**
 * Enum trạng thái tài sản
 */
export default {
  InUsed: 2,
  Disposed: 3,
  InUsedDepreciation: 4,
  NotDepreciation: 5,
};
